import Vue from 'vue';
import Vuetify from 'vuetify/lib/framework';

Vue.use(Vuetify);

export default new Vuetify({
    theme:{
        themes:{
            light:{
                primary : '#37b34a',
                secondary : '#F6921E',
                warning: '#F6921E'
            }
        }
    }
});
